import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import {
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CRow,
	CCol,
	CTooltip,
	CLink,
	CListGroup,
	CListGroupItem,
	CForm,
	CFormInput,
	CInputGroup,
	CInputGroupText,
	CButton,
	CFormSelect,
	CSpinner,
	CBadge,
	CDropdown, CDropdownItem, CDropdownToggle, CDropdownMenu,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { 
	MyPagination,
	MyDialogform,
	MyDialogview,
	MyDialoglookup,
	MyPage500,
} from '../components/index';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";

const pjson     	= require('../../package.json');
const Hutangjpl		= (props) => {
	const uComponentname 	= Hutangjpl.name;
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	const uNavigate  		= useNavigate();
	const uDispatch			= useDispatch();
	const uTokenObj			= JSON.parse(localStorage.getItem("token"));
	const uBahasaObj  		= useSelector(state => state.listBahasa);
	const uActiveroute  	= useSelector(state => state.activeRoute);
	const uHTMLstyleTabel	= useSelector(state => state.gHTMLstyleLaporan);
	const uIsScrollBottom	= useSelector(state => state.gIsScrollBottom);
	const uIsEOMExecuted	= useSelector(state => state.gIsEOMExecuted);
	const uDefaultSettingObj= useSelector(state => state.gListDefaultSetting);
	const uUserSettingObj 	= useSelector(state => state.gListUserSetting);
	const uEfekapp			= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] = React.useState(false);

	//--GLOBAL_VARS--/
	const uIsAllowedbayar	= uIsEOMExecuted
	const uMaxData			= isMobile ? (uUserSettingObj.jml_mobile || 20) : (uUserSettingObj.jml_laporan || 100);
	const [uHTMLError500,setHTMLError500]	= React.useState(null);

	//---DATA--/
	const uKeywordObj						= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uHeaderActionObj  				= useSelector(state => state.gInitHeaderAction);
	const uHandelView 						= uHeaderActionObj.isHeaderView || false;
	const uHandelPreview 					= uHeaderActionObj.isHeaderPreview || false;
	const [uFirstload,setFirstload]			= React.useState("YA");
	const uKasGLloadArr						= JSON.parse(localStorage.getItem("kasgllist") || "[]");

	const [uJmlData,setJmlData]				= React.useState(0);
	const [uJmlHal,setJmlHal]				= React.useState(1);
	const [uPageActive,setPageActive]		= React.useState(0);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uDatamainArr,setDatamainArr]		= React.useState([]);
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);

	const uElJmldata	= document.getElementById("idjmldata");
	//---END DATA--/

	//--FORMDIALOG--/
	const [uKasGLArr,setKasGLArr]			= React.useState([]);//-*/

	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});

	const [uElBtnDlgsimpan,setElBtnDlgsimpan]= React.useState(document.getElementById("btnDialogSimpan"));
	//--END FORMDIALOG--/

	//--DLG_VIEW--/
	const [uISDlgviewshow,setDlgviewshow]	= React.useState(false);
	const [uDlgviewObj,setDlgviewObj]		= React.useState({});
	const [uDatahistoriArr,setDatahistoriArr]= React.useState([]);
	//--END DLG_VIEW--/

	//--DLG_LOOKUP--/
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	//--END DLG_LOOKUP--/
	//--END GLOBAL_VARS--/

	//---HANDLE--/
	const hdlKlikDlgformsimpan = () => {
		const vArridx		= UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);
		if(vArridx < 0) return;

		//---VALIDASI--/
		let vElfocus = document.getElementById("inptglbayar");
		if(UFunc.isEmpty(uDlgformObj.tgl_bayar)) {
			vElfocus && vElfocus.focus();
			showToast((uBahasaObj.caption_tglbayar||"caption_tglbayar")+" "+uBahasaObj.caption_invalid+"..");
			return;
		}

		const vTanggalDt 	= UFunc.toDate(uDlgformObj.tgl_bayar);
		const vDateBeyond 	= UFunc.DateIsBeyond(vTanggalDt);
		if(vDateBeyond) {
			vElfocus && vElfocus.focus();
			showToast((uBahasaObj.pesan_tglisbeyond||"pesan_tglisbeyond")+"..");
			return;
		}
		const vDateExceededBl = UFunc.DateIsExceededYear(vTanggalDt);
		if(vDateExceededBl) {
			vElfocus && vElfocus.focus();
			showToast((uBahasaObj.pesan_tglisexpiredyear||"pesan_tglisexpiredyear")+"..");
			return;
		}
		const vTglHutangDt = UFunc.toDate(uDatamainArr[vArridx].tgl_hutang);
		if(vTanggalDt < vTglHutangDt) {
			vElfocus && vElfocus.focus();
			showToast("<b>Tanggal Bayar Tidak Valid</b>.."+
				"<br/>Tanggal Bayar Harus Dilakukan Sesudah Tanggal Hutangnya."+
				"<br/>Mohon Diperbaiki !");
			return;	
		}

		vElfocus = document.getElementById("inpnilaibayar");
		if((parseFloat(uDlgformObj.nilai_bayar)||0) <= 0 ) {
			vElfocus && vElfocus.focus();
			if((parseFloat(uDlgformObj.nilai_bayar)||0) < 0 )
				showToast((uBahasaObj.caption_nilaibayar||"caption_nilaibayar")+" "+uBahasaObj.caption_invalid+".."+
					"<br/><b>Kemungkinan Anda memasukkan Nilai Selain Angka.</b>"+
					"<br/>(Nilai = "+uDlgformObj.nilai_bayar+")"+
					"<br/><br/>Mohon Ulangi untuk Menginput ANGKA dengan BENAR !"+
					"");
			else
				showToast((uBahasaObj.caption_nilaibayar||"caption_nilaibayar")+" "+uBahasaObj.caption_invalid+".."+
					"");
			return;
		}
		vElfocus = document.getElementById("inpkascaption");
		if((parseInt(uDlgformObj.kas_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast((uBahasaObj.caption_asalkas||"caption_kaspenerima")+
				" "+(uBahasaObj.caption_mustchoose||"caption_mustchoose")+"..");
			return;
		}
		//---END VALIDASI--/

		apiSimpanbayar();
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		const vIdx = UFunc.getObjectIndeks(uDlglookupObj.data_arr,_IDITEM,"id");
		if(vIdx < 0) return;

		const vElsfocusnext = uElBtnDlgsimpan;
		uDlgformObj.kas_id = (uDlglookupObj.data_arr[vIdx].id)
		uDlgformObj.kas_caption = (uDlglookupObj.data_arr[vIdx].caption)
		setDlglookupshow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			vElsfocusnext && vElsfocusnext.focus()
		},350);
	}
	const hdlKlikKaslookup = () => {
		//uDlglookupObj.inputvalue = (uDlgformObj.kas_caption);
		uDlgformObj.kas_caption = (""); uDlgformObj.kas_id = ("");
		const vTmpArr	= uKasGLArr.map((vItems)=>{
			return {id:vItems.value,caption:vItems.caption}
		})
		uDlglookupObj.data_arr = (vTmpArr);
		uDlglookupObj.headers = (uBahasaObj.word_pilih+": "+(uBahasaObj.caption_asalkas||"").toUpperCase());
		setDlglookupshow(true)
	}

	const hdlKlikHistori = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
		setTabelIDPilih(_IDTABEL);

		//alert(vArridx);return;
		uDlgviewObj.headers = uBahasaObj.caption_historibayar+": "+
			(uDatamainArr[vArridx].nama_supplier||"").toUpperCase();
		uDlgviewObj.jenis 	= "HISTORI";
		if((uDatamainArr[vArridx].histori_arr||[]).length > 0) {
			setDatahistoriArr(uDatamainArr[vArridx].histori_arr||[]);
			setDlgviewshow(true);
			return;
		}
		apiLoadhistori(_IDTABEL);
	}
	const hdlKlikDetil = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
		setTabelIDPilih(_IDTABEL);

		//alert(vArridx);return;
		uDlgviewObj.headers = (uBahasaObj.caption_detiltransaksi||"Detil Transaksi")+": "+
			(uDatamainArr[vArridx].nama_supplier||"").toUpperCase();
		uDlgviewObj.jenis 	= "DETIL";
		if(!UFunc.isEmpty(uDatamainArr[vArridx].detil_obj)) {
			setDlgviewshow(true);
			return;
		}
		apiLoaddetil(_IDTABEL);
	}
	const hdlKlikBayar = (_IDTABEL) =>{
		_IDTABEL = parseInt(_IDTABEL) || 0;
		if(_IDTABEL <= 0) return;

		var vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
		setTabelIDPilih(_IDTABEL);

		const vSisaHutang	= (parseInt(uDatamainArr[vArridx].nilai_hutang)||0)
			- (parseInt(uDatamainArr[vArridx].terbayar)||0);
		const vHeadercaption= (uBahasaObj.caption_bayarhutang||"caption_bayarhutang")+": "+
			(uDatamainArr[vArridx].nama_supplier||"").toUpperCase()+
			" ("+(uBahasaObj.word_sisa||"word_sisa")+" Rp "+UFunc.formatAngka(vSisaHutang)+")"+
			"";
		uDlgformObj.tgl_bayar	= UFunc.DbDate();
		uDlgformObj.status_jurnal	= "REGULER";
		uDlgformObj.nilai_bayar	= 0;
		uDlgformObj.headers 	= vHeadercaption;
		setDlgformshow(true);
	}
	//---END HANDLE--/

	//---INIT_FUNCTION--/
	const initJmldata=()=>{
		const vKeyword = uKeywordObj.kwd_hutangjpl || "";
		if (vKeyword.length > 2) 
			uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
		else
			uElJmldata && (uElJmldata.innerHTML = "&#8734;");
	}
	//---END INIT_FUNCTION--/

	//---Init_CONTENT--/
	const contentMain = () => {
		if(uHTMLError500) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_hutangjpl || "");
		const vKeywordcolor = uUserSettingObj.color_keyword;
		const vReplace 		= new RegExp(vKeyword,"ig");

		//const vDataviewArr	= isMobile ? uDatamainArr.slice(0,(vMax+1)) : uDatamainArr.slice(vMin,(vMax+1));
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.pg||1)===parseInt(uPageActive||1))

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row align-top text-center classfontsmaller">
			<th width="5%" className="px-1">No</th>
			<th className="px-1">
				<CRow className="mx-0">
				<CCol md="2" className="text-start">{uBahasaObj.word_tanggal||"word_tanggal"}</CCol>
				<CCol md="2" className="text-start">{uBahasaObj.caption_pihaklain||"Pihak Lain"}</CCol>
				<CCol md="2" lg="3" className="text-start">{uBahasaObj.word_keterangan||"word_keterangan"}</CCol>
				<CCol md="3" className="d-flex justify-content-between">
					<div className="w-50">{uBahasaObj.caption_nilaihutang||"caption_nilaihutang"}<small className="ms-1">(Rp)</small></div>
					<div className="w-50">{uBahasaObj.word_terbayar||"word_terbayar"}<small className="d-block">(Rp)</small></div>
				</CCol>
				<CCol md="2" lg="1" className="">{uBahasaObj.caption_sisahutang||"caption_sisahutang"}<small className="d-block">(Rp)</small></CCol>
				<CCol md="1" className="">&middot;</CCol>
				</CRow>
			</th>
			</tr>
			<tr className="d-md-none classfontsmaller">
			<th width={25} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>
		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				id,nama_supplier,tgl_hutang,nilai_hutang,tgl_input,terbayar,
				no_rek,ket,is_loading
			} = vItems;

			vNumber++;
			const vCaptionUpper	= ((nama_supplier||"")+": "+
				UFunc.TglAngka(tgl_hutang)).toUpperCase();

			const vNamaSupplier	= vKeyword==="" ? UFunc.capitalize(nama_supplier||"") 
				: (UFunc.capitalize(nama_supplier||"")).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vKeterangan = vKeyword==="" ? (ket||"-") 
				: (ket||"-").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vNorek= vKeyword==="" ? (no_rek||"") 
				: (no_rek||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vTglHutang= vKeyword==="" ? UFunc.TglAngka(tgl_hutang||"") 
				: (UFunc.TglAngka(tgl_hutang||"")).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
				
			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uTabelRowSelect===vKeys?" classrowselect":"")}>
				<td className="px-1 pe-0">{(vNumber)}.</td>
				<td className="px-1">
				<CRow className="mx-0">
				<CCol md="2" className="px-1 d-none d-md-block text-md-start">
					<div>
					{UFunc.renderHTML(vTglHutang)}
					{uTokenObj.userhak==="FREEROLE" && (<span className="classfontsmaller"><small> &middot; ({id})</small></span>)}
					</div>	
				</CCol>

				<CCol xs="12" md="2" className="px-1 text-start d-flex justify-content-between align-items-start">
					<div>
						<div className="text-info">{UFunc.renderHTML(vNamaSupplier)}</div>
						{(no_rek||"")!=="" && (
							<div className="fst-italic classfontsmaller">
							<small>({uBahasaObj.word_rek||"word_reks"}: {UFunc.renderHTML(vNorek)})</small>
							</div>
						)}	
					</div>

					{(is_loading||false)===true ? (
						<CSpinner color="dark" className="d-md-none" size="sm"/>
					) : (
					<CDropdown className="d-md-none">
						<CDropdownToggle caret={false} size="sm" className="p-0"
							color="transparent">
							<CIcon icon="cilOptions" className="classikoncoreui" height={25}/>
						</CDropdownToggle>
						<CDropdownMenu>
						{uIsEOMExecuted && (
						<CDropdownItem onClick={()=>hdlKlikBayar(id)}>
							<CIcon className="classikonbayar me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_bayarhutang)}
						</CDropdownItem>
						)}
						
						<CDropdownItem onClick={()=>hdlKlikHistori(id)}>
							<CIcon className="classikonhistoribayar me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_historibayar)}
						</CDropdownItem>
						<CDropdownItem onClick={()=>hdlKlikDetil(id)}>
							<CIcon className="classikondetil me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_detiltransaksi||"Detil Transkasi")}
						</CDropdownItem>
						</CDropdownMenu>
					</CDropdown>
					)}
				</CCol>

				<CCol xs="12" className="d-md-none my-3 classborderbottom"/>
				
				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.word_tanggal||"word_tanggal"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					{UFunc.renderHTML(vTglHutang)}
					{uTokenObj.userhak==="FREEROLE" && (<span className="classfontsmaller"><small> &middot; ({id})</small></span>)}
				</CCol>

				<CCol xs="3" className="px-1 d-md-none text-start classfontsmaller">{uBahasaObj.word_keterangan||"word_keterangan"}</CCol>
				<CCol xs="9" md="2" lg="3" className="px-1 text-md-start">
					<small className="fst-italic">{UFunc.renderHTML(vKeterangan)}</small>
				</CCol>

				<CCol md="3" className="px-0 d-none d-md-flex justify-content-between">
					<small className="w-50 px-1">
					<span className="d-md-none">Rp </span>{UFunc.formatAngka(nilai_hutang)}
					</small>

					<small className="w-50 px-1">
					<div className="">{UFunc.formatAngka(terbayar)}</div>
					</small>
				</CCol>

				<CCol xs="12" className="d-md-none my-3 classborderbottom"/>

				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_nilaihutang||"caption_nilaihutang"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					<span className="d-md-none">Rp </span>{UFunc.formatAngka(nilai_hutang)}
				</CCol>

				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.word_terbayar||"word_terbayar"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					<div className="">{UFunc.formatAngka(terbayar)}</div>
				</CCol>

				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_sisahutang||"caption_sisahutang"}</CCol>
				<CCol xs="6" md="2" lg="1" className="px-1 text-primary">
					<span className="d-md-none">Rp </span>{UFunc.formatAngka(nilai_hutang - terbayar)}
				</CCol>

				<CCol md="1" className="text-md-center px-0 d-none d-md-block">
					{(is_loading||false)===true ? (
						<CSpinner color="primary" className="" size="sm"/>
					) : (
					<>
						{(uIsEOMExecuted) && (
						<CTooltip content={"--"+(uBahasaObj.caption_bayarhutang||"caption_bayarhutang")+": "+vCaptionUpper}>
						<CLink 
							className="d-md-none d-lg-inline-block classcursorpointer classikontabel classikonbayar classikoncoreui mx-0 me-lg-1"
							onClick={()=>hdlKlikBayar(id)}/>
						</CTooltip>
						)}

						<CDropdown>
						<CDropdownToggle caret={false} size="sm" className="p-0"
							color="transparent">
							<CIcon icon="cilChevronBottom" className="classikoncoreui" height={24}/>
						</CDropdownToggle>
						<CDropdownMenu>
						<CDropdownItem className="classcursorpointer d-lg-none" onClick={()=>hdlKlikBayar(id)}>
							<CIcon className="classikonbayar me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_bayarhutang)}
						</CDropdownItem>>
						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikHistori(id)}>
							<CIcon className="classikonhistoribayar me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_historibayar)}
						</CDropdownItem>
						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikDetil(id)}>
							<CIcon className="classikondetil me-2 align-middle" height={25}/>
							{(uBahasaObj.caption_detiltransaksi||"Detil Transaksi")}
						</CDropdownItem>
						</CDropdownMenu>
						</CDropdown>
					</>
					)}
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>);

		return (
		<CForm>
			{uTokenObj.userhak === "FREEROLE" && (
			<>
			<CRow className="my-2">
			<CCol xs="4" className="text-md-end text-info">
				{uBahasaObj.caption_statustembakjurnal||"Status Jurnal"}
			</CCol>
			<CCol xs="8" lg="4">
				<CFormSelect size="sm"
						onChange={(e)=>{uDlgformObj.status_jurnal=e.target.value;setEfekview(!uEfekview)}}
						value={uDlgformObj.status_jurnal}
						id="inpstatustembak">
					<option value="REGULER">Input REGULER</option>
					<option value="TEMBAK">Input TEMBAK DATA</option>
				</CFormSelect>

				<div className="classpetunjuk">
				</div>
			</CCol>
			<CCol lg="4" className="d-none d-lg-block"/>
			<CCol xs="4" className=""/>
			<CCol xs="8" className="classpetunjuk">
				<small>*) Jika TEMBAK DATA, Anda Harus Menginput JURNAL SECARA MANUAL</small>
			</CCol>
			</CRow>
			<div className="my-3 classborderbottom"/>
			</>
			)}

			<CRow className="my-2">
			<CCol xs="4" className="text-start text-md-end text-info">{uBahasaObj.caption_tglbayar||"caption_tglbayar"}</CCol>
			<CCol xs="8" lg="4">
				<CFormInput
					size="sm"
					type="date"
					value={uDlgformObj.tgl_bayar||""}
					onChange={(e)=>{uDlgformObj.tgl_bayar=e.target.value;setEfekview(!uEfekview)}}
					id="inptglbayar"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol xs="4" className="text-start text-md-end">{uBahasaObj.word_nonota||"word_nonota"}</CCol>
			<CCol xs="8" lg="4">
				<CFormInput maxLength={20}
					size="sm"
					value={uDlgformObj.no_nota||""}
					className="text-uppercase"
					onChange={(e)=>{uDlgformObj.no_nota=e.target.value;setEfekview(!uEfekview)}}
					id="inpnonota"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol xs="4" className="text-start text-md-end text-info">{uBahasaObj.caption_nilaibayar||"caption_nilaibayar"}</CCol>
			<CCol xs="8" lg="4">
				<NumberFormat 
					value={uDlgformObj.nilai_bayar||0}
					displayType={'text'} 
					thousandSeparator={"."} 
					decimalSeparator={","}
					allowNegative={false}
					onValueChange={(values) => uDlgformObj.nilai_bayar = (values.value)}
					renderText={values => (
						<CFormInput 
							value={values}
							onChange={(e)=>{uDlgformObj.nilai_bayar=e.target.value;setEfekview(!uEfekview)}}
							size="sm"
							className="text-end"
							onFocus={(e)=>e.target.select()}
						id="inpnilaibayar"/>
					)} 
				prefix={isMobile?"":"Rp"}/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol xs="4" className="text-start text-md-end text-info">{uBahasaObj.caption_asalkas||"caption_asalkas"}</CCol>
			<CCol xs="8" lg="4">
				<CInputGroup size="sm">
					<CFormInput size="sm"
						readOnly={true}
						value={uDlgformObj.kas_caption||""}
						onClick={()=>hdlKlikKaslookup()}
						placeholder={"--"+uBahasaObj.word_pilih+": "+(uBahasaObj.caption_asalkas)+".."}
						id="inpkascaption"/>
					<CButton size="sm" color="dark"
						onClick={()=>hdlKlikKaslookup()}
						id="btnkaslookup">
					<CIcon icon="cilMagnifyingGlass"/>
					</CButton>
				</CInputGroup>
			</CCol>
			</CRow>
		</CForm>
		)
	}
	const contentDlgview = () => {
		if(!uISDlgviewshow) return (<></>)

		if(uDlgviewObj.jenis==="HISTORI") return contentViewhistori();
		if(uDlgviewObj.jenis==="DETIL") return contentViewdetil();

		return (<></>);
	}
	const contentViewdetil = () => {
		if(uDlgviewObj.jenis!=="DETIL") return (<></>);

		const vArridx = UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);
		if(vArridx < 0) return (<></>);

		const vDatadetilObj = uDatamainArr[vArridx].detil_obj || {};
		const vDataitemArr	= vDatadetilObj.item_arr || [];

		return (
		<small>
		<CRow>
		<CCol lg="5">
			<CCard className="mb-3">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Data Transaksi</CCardHeader>
			<CCardBody>
				<div className="d-flex justify-content-between my-1">
				<small className="">Tgl Transaksi</small>
				<div className="text-end">{UFunc.HariAngka(vDatadetilObj.tgl_transaksi)}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="">Nota Transaksi</small>
				<div className="text-end">{(vDatadetilObj.no_nota||"-")}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="">Customer</small>
				<div className="text-end fw-bolder">{(vDatadetilObj.customer_caption||"-")}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="">Pihak Lain</small>
				<div className="ps-1 text-end text-info">{(uDatamainArr[vArridx].nama_supplier||"-")}</div>
				</div>
			</CCardBody>
			</CCard>
		</CCol>

		<CCol lg="7">
			<CCard className="mb-3">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Item Transaksi</CCardHeader>
			<CCardBody className="px-0">
			<table className="table table-borderless table-striped" id="idtabelitem">
			<thead>
			<tr className="p-0">
				<th width="5%" className="p-0"/>
				<th className="p-0"/>
				<th width="25%" className="p-0"/>
			</tr>
			</thead>
			<tbody>
			{vDataitemArr.map((vItems,vKeys)=>{
				const {
					id,pasien_caption,item_caption,h_jual_sat,qty
				} = vItems;

				return (
				<tr className="text-end align-top"
					key={vKeys}>
					<td className="text-end px-1">{vKeys+1}.</td>
					<td className="text-start px-1">
						<div className="d-flex">
						<b>[{pasien_caption}]</b>

						<div className="ps-2" style={{minWidth:"70%"}}>
							{item_caption}
							<small className="d-block fst-italic">
							({UFunc.formatAngka(qty)} x {UFunc.formatAngka(h_jual_sat)})
							</small>
						</div>
						</div>
					</td>
					<td className="text-end px-1 text-primary">
						{UFunc.formatAngka(parseInt(qty||0) * parseFloat(h_jual_sat||0))}
					</td>
				</tr>
				)
			})}
			</tbody>
			</table>
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>
		</small>
		);
	}
	const contentViewhistori = () => {
		if(uDlgviewObj.jenis!=="HISTORI") return (<></>);

		const vArridx = UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);
		if(vArridx < 0) return (<></>);

		return (
		<small>
		<CRow className="">
		<CCol lg="6">
			<CCard className="mb-3">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Data Hutang</CCardHeader>
			<CCardBody>
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Tgl Hutang</small>
				<div className="px-1 text-end">{UFunc.HariAngka(uDatamainArr[vArridx].tgl_hutang)}</div>
				</div>
				
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Supplier</small>
				<div className="px-1 text-end text-info">{uDatamainArr[vArridx].nama_supplier}</div>
				</div>
				
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Keterangan</small>
				<div className="px-1 text-end fst-italic">{uDatamainArr[vArridx].ket||"-"}</div>
				</div>
					
				<div className="px-1 my-3 classborderbottom"/>
				
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Nilai Hutang (Rp)</small>
				<div className="px-1 text-end">{UFunc.formatAngka(uDatamainArr[vArridx].nilai_hutang)}</div>
				</div>
				
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Terbayar (Rp)</small>
				<div className="px-1 text-end">{UFunc.formatAngka(uDatamainArr[vArridx].terbayar)}</div>
				</div>
				
				<div className="d-flex justify-content-between my-1">
				<small className="px-1">Sisa Hutang (Rp)</small>
				<div className="px-1 text-end text-primary fw-bolder">{UFunc.formatAngka(uDatamainArr[vArridx].nilai_hutang - uDatamainArr[vArridx].terbayar)}</div>
				</div>
			</CCardBody>
			</CCard>
		</CCol>

		<CCol lg="6">
			<CCard className="mb-3">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Riwayat Pembayaran</CCardHeader>

			<CCardBody className="px-0">
			{uDatahistoriArr.map((vItems,vKeys)=>{
				const {
					id,tgl_bayar,ket,nilai_bayar
				} = vItems;

				const vBgcolor 	= vKeys%2===0 ? "light" : "white";
				const vAccent 	= vKeys%2===0 ? "success" : "warning";
				return (
					<div className={(vKeys<=0?"border-top ":"")+"p-1 py-2 classborderbottom border-start border-start-4 border-start-"+vAccent} 
						key={vKeys}>
					<CRow className="mx-0">
					<CCol xs="12" md="8" className="px-1">
						<div className="fw-bolder">{UFunc.HariAngka(tgl_bayar||"")}</div>
						{(ket||"")!=="" && (
						<div className="fst-italic d-none d-md-block">
							<small>
							<span className="d-none d-md-inline">{uBahasaObj.word_nota||"Nota"}: </span>
							<span className="text-info text-uppercase">{UFunc.capitalize(ket||"")}</span>
							</small>
						</div>
						)}
					</CCol>

					<CCol xs="12" className="d-md-none px-1 my-2 classborderbottom"/>

					<CCol xs="5" className="d-md-none px-1">{uBahasaObj.word_nota||"Nota"}</CCol>
					<CCol xs="7" className="text-end px-1 d-md-none">
						<span className="text-info text-uppercase">{UFunc.capitalize(ket||"-")}</span>
					</CCol>
					
					<CCol xs="5" className="d-md-none px-1">{uBahasaObj.caption_nilaibayar||"caption_nilaibayar"}</CCol>
					<CCol xs="7" md="4" className="text-end px-1">
						<div className="text-primary">Rp{UFunc.formatAngka(nilai_bayar)}</div>
					</CCol>
					</CRow>
					</div>
				)
			})}
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>
		</small>
		)
	}
	//---END Init_CONTENT--/

	//---API_FUNC--/
	const apiLoaddata = (_PAGE) => {
		_PAGE		= parseInt(_PAGE) || 1;
		setHTMLError500();

		const vKeyword 		= uKeywordObj.kwd_hutangjpl || "";
		const vHandelview	= ((uHandelView||false)===true || uFirstload==="YA")
			?"YA":"TIDAK";
		let vDatamainArr 	= uDatamainArr;
		if(vHandelview==="YA") {
			vDatamainArr	= [];
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===1);
			} else {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)!==_PAGE);
			}
		}
		setLoading(true);
		//const vKasGLDefaultArr = JSON.parse(localStorage.getItem("kasgllist"));

		/*//--TESTING_FRONTEND--/
		console.log("(Hutangjpl-apiLoaddata) LEWAT ");
		return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_firstload : uFirstload,
			send_keyword : vKeyword,
			send_pg: _PAGE,
			send_maxdata	: uMaxData,
			send_loadjml	: vHandelview,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_hutangjpl/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			//console.log("(Hutangjpl-apiLoaddata) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				let vTmpObj = JSON.parse(output_string.dataobject||"[]");
				vTmpObj.map(vItems=>vItems.pg = _PAGE);

				setDatamainArr([...vDatamainArr,...vTmpObj]);
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.totaldata||uJmlData))
				else setJmlData(vTmpObj.length);

				if(uFirstload==="YA") {
					vTmpObj = JSON.parse(output_string.kastambahanobj || "[]");
					setKasGLArr([...uKasGLloadArr,...vTmpObj]);
				}
				setFirstload("TIDAK");

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Hutangjpl - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Hutangjpl - apiLoaddata) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadhistori = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		uDatamainArr[vArridx].is_loading = true;
		setEfekview(!uEfekview);

		/*//--TESTING_FRONTEND--/
		console.log("(Hutangjpl-apiLoadhistori) LEWAT ");
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_hutangid : _IDTABEL.toString(),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_hutangjpl/ld_histori";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			uDatamainArr[vArridx].is_loading = false;
			setLoading(false);
			//console.log("(Hutangjpl - apiLoadhistori) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vTmpArr = JSON.parse(output_string.historiobject || "[]");
				if(vTmpArr.length <= 0) {
					showToast((uBahasaObj.caption_dataempty||"caption_dataempty")+"..");
					return;
				}
				setDatahistoriArr(vTmpArr);
				uDatamainArr[vArridx].histori_arr = vTmpArr;
				setDlgviewshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Hutangjpl - apiLoadhistori) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx].is_loading = false;
			console.log("(Hutangjpl - apiLoadhistori) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiLoaddetil = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		uDatamainArr[vArridx].is_loading = true;
		setEfekview(!uEfekview);

		/*//--TESTING_FRONTEND--/
		console.log("(Hutangjpl-apiLoadhistori) LEWAT ");
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_hutangid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_hutangjpl/ld_detil";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			uDatamainArr[vArridx].is_loading = false;
			//console.log("(Hutangjpl- apiLoaddetil) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vTmpObj = JSON.parse(output_string.detilobject || "{}");
				if(UFunc.isEmpty(vTmpObj)) {
					showToast((uBahasaObj.caption_dataempty||"caption_dataempty")+"..");
					return;
				}
				uDatamainArr[vArridx].detil_obj = vTmpObj;
				setDlgviewshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Hutangjpl - apiLoaddetil) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx].is_loading = false;
			console.log("(Hutangjpl-apiLoaddetil) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiSimpanbayar = () => {
		const vHutangID = parseInt(uTabelIDPilih) || 0;
		if(vHutangID <= 0) return;
		const vIdx 	= UFunc.getObjectIndeks(uDatamainArr,vHutangID);
		uElBtnDlgsimpan && (uElBtnDlgsimpan.disabled=true);

		setLoading(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_hutangid : vHutangID,
			send_parsinput: JSON.stringify(uDlgformObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_hutangjpl/pr_simpanbayar";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			uElBtnDlgsimpan && (uElBtnDlgsimpan.disabled=false);
			//console.log("(Hutangjpl-apiSimpanbayar) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.sukses) {
				uDatamainArr[vIdx].terbayar = (parseInt(uDatamainArr[vIdx].terbayar)||0) + (parseInt(uDlgformObj.nilai_bayar)||0);
				setDlgformshow(false);

				if(output_string.pesankhusus) {
					const vPesan = output_string.pesankhusus;
					showToast(vPesan,"SUKSES");
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Hutangjpl-apiSimpanbayar) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true);
				prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnDlgsimpan && (uElBtnDlgsimpan.disabled=false);
			setLoading(false);
			console.log("(Hutangjpl-apiSimpanbayar) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API_FUNC--/

	//---EFFECT--/
	React.useEffect(()=>{
		setKasGLArr(uKasGLloadArr);
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	apiLoaddata();

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false); setDlgviewshow(false);setDlglookupshow(false)
			setDatamainArr([]);
    		setDatahistoriArr([]);
    		setKasGLArr([]);
    	}
	},[]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setJmlData(0);
		setDatamainArr([]);
		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		setPageActive(1);

		apiLoaddata();
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelPreview) return;

		uHeaderActionObj.isHeaderPreview = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		uNavigate("/subkeuangan/hutangjpl/listdata"); 
	},[uHandelPreview]);
	React.useEffect(()=>{ uElJmldata && initJmldata() },[uElJmldata]);
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata();
	},[uJmlData]);
	React.useEffect(()=>{ 
		if(uFirstload==="YA") return;

		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
	},[uPageActive]);
	React.useEffect(()=>{
		if(!uISDlgviewshow) {
			setDlgviewObj({});setTabelIDPilih(0);
			return;
		}
	},[uISDlgviewshow]);
	React.useEffect(()=>{
		if(!uISDlgformshow) {
			setDlgformObj({});
			return;
		}

		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);
			setElBtnDlgsimpan(document.getElementById("btnDialogSimpan"))
			const vElfocus = document.getElementById("inptglbayar") 
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			uDlglookupObj.inputvalue = (""); uDlglookupObj.data_arr = ([]);
			return
		}
	},[uISDlglookupshow]);
	React.useEffect(()=>{
		if((parseInt(uDlgformObj.nilai_bayar)||0) < 0) 
			{ uDlgformObj.nilai_bayar = ((parseInt(uDlgformObj.nilai_bayar)||0) * -1); return; }
		if((parseInt(uTabelIDPilih)||0) <= 0) return; 

		const vIdx 	= UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);
		if((parseInt(uDlgformObj.nilai_bayar)||0) > (parseInt(uDatamainArr[vIdx].nilai_hutang)||0) - (parseInt(uDatamainArr[vIdx].terbayar)||0)) 
			uDlgformObj.nilai_bayar = ((parseInt(uDatamainArr[vIdx].nilai_hutang)||0) - (parseInt(uDatamainArr[vIdx].terbayar)||0));
	},[uDlgformObj.nilai_bayar]);
	//---END EFFECT--/

	//console.log("(Hutangjpl) Checked..");//---KALO_GA_ADA_YG_PAKE_uComponentname
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHTMLError500) return (<MyPage500 content={uHTMLError500} {...props}/>)

	return (
		<>
		<CCard card="classcardbg">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<small className="text-primary">
				<span className="d-md-none fw-bolder">
				{(()=>{
					const vKeyword = uKeywordObj.kwd_hutangjpl || "";
					if(vKeyword.length < 3) {
						return (<>&#8734;</>)
					}

					return "("+UFunc.formatAngka(uJmlData)+")"
				})()}
				</span>
			</small>

			<div className="d-lg-none"/>
			<div className="text-muted classfontsmaller"><small>{UFunc.formatAngka(uTimeElapsed)}ms</small></div>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.headers||""}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.data_arr||[]} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{size:"lg",centered:false}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.headers || ""}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}
			{...props}/>

		<MyDialogview
			options={{size:"lg",centered:false}}
			show={uISDlgviewshow} 
			dialogHeader={uDlgviewObj.headers || ""}
			toggle={()=>setDlgviewshow(false)}
			renderContent={contentDlgview()}/>
		</>
	)
}
	
export default Hutangjpl;
